module.exports = __webpack_public_path__ + "static/media/tracker_screenshot_ru.17352ecf.png";